"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerCommands = exports.HostCommands = exports.ProtocolCommands = void 0;
var ProtocolCommands;
(function (ProtocolCommands) {
    ProtocolCommands["Input.dispatchKeyEvent"] = "Input.dispatchKeyEvent";
    ProtocolCommands["Input.emulateTouchFromMouseEvent"] = "Input.emulateTouchFromMouseEvent";
})(ProtocolCommands = exports.ProtocolCommands || (exports.ProtocolCommands = {}));
var HostCommands;
(function (HostCommands) {
    HostCommands["start"] = "start";
    HostCommands["run"] = "run";
    HostCommands["close"] = "close";
    HostCommands["setViewport"] = "setViewport";
})(HostCommands = exports.HostCommands || (exports.HostCommands = {}));
var WorkerCommands;
(function (WorkerCommands) {
    WorkerCommands["startComplete"] = "startComplete";
    WorkerCommands["runComplete"] = "runComplete";
    WorkerCommands["screencastFrame"] = "screencastFrame";
    WorkerCommands["browserClose"] = "browserClose";
    WorkerCommands["error"] = "error";
})(WorkerCommands = exports.WorkerCommands || (exports.WorkerCommands = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxnQkFHWDtBQUhELFdBQVksZ0JBQWdCO0lBQzFCLHFFQUFtRCxDQUFBO0lBQ25ELHlGQUF1RSxDQUFBO0FBQ3pFLENBQUMsRUFIVyxnQkFBZ0IsR0FBaEIsd0JBQWdCLEtBQWhCLHdCQUFnQixRQUczQjtBQUVELElBQVksWUFLWDtBQUxELFdBQVksWUFBWTtJQUN0QiwrQkFBaUIsQ0FBQTtJQUNqQiwyQkFBYSxDQUFBO0lBQ2IsK0JBQWlCLENBQUE7SUFDakIsMkNBQTZCLENBQUE7QUFDL0IsQ0FBQyxFQUxXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBS3ZCO0FBRUQsSUFBWSxjQU1YO0FBTkQsV0FBWSxjQUFjO0lBQ3hCLGlEQUFpQyxDQUFBO0lBQ2pDLDZDQUE2QixDQUFBO0lBQzdCLHFEQUFxQyxDQUFBO0lBQ3JDLCtDQUErQixDQUFBO0lBQy9CLGlDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFOVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQU16QiJ9